// src/App.js
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import CompanyView from './pages/Company/Empresa/companyView';
import EditCompanyView from './pages/Company/Empresa/editCompanyInfoView';
import SucursalesView from './pages/Company/Sucursales/Sucursalesview';
import SucursalesEditView from './pages/Company/Sucursales/SucursalesEditView';
import SucursalesCreateView from './pages/Company/Sucursales/sucursalesCreateView';
import DispositivosView from './pages/Settings/Dispositivos/DispositivosView';
import DispositivosEditView from './pages/Settings/Dispositivos/DispositivosEditView';
import DispositivosCreateView from './pages/Settings/Dispositivos/DispositivosCreateView';
import ReportView from './pages/Report/reportView';
import LoginView from './pages/Login/login';
import PrivateRoute from './components/privateRoute';
import ComandosPendientesView from './pages/Settings/Comandos/ComandosPendientesview';
import { useTokenRefresher } from './hooks/UseTokenRefresher';
import EmpleadosView from './pages/Company/Empleados/EmpleadosView';
import EmpleadosEditView from './pages/Company/Empleados/EmpleadosEditView';
import EmpleadosCreateView from './pages/Company/Empleados/EmpleadosCreateView';
import HorarioView from './pages/Horarios/Horario/HorarioView';
import HorarioEditView from './pages/Horarios/Horario/HorarioEditView';
import HorarioCreateView from './pages/Horarios/Horario/HorarioCreateView';
import TurnoView from './pages/Horarios/Turno/TurnoView';
import TurnoCreateView from './pages/Horarios/Turno/TurnoCreateView';
import TurnoEditView from './pages/Horarios/Turno/TurnoEditView';


function App() {
  useTokenRefresher()
  return (

    <BrowserRouter>
      <Routes>
        {/* Ruta para Login sin Sidebar */}
        <Route path="/login" element={<LoginView />} />

        {/* Rutas protegidas usando PrivateRoute */}
        <Route path="/" element={<PrivateRoute element={<CompanyView />} />} />
        <Route path="/company" element={<PrivateRoute element={<CompanyView />} />} />
        <Route path="/company/editCompany" element={<PrivateRoute element={<EditCompanyView />} />} />

        <Route path="/sucursales" element={<PrivateRoute element={<SucursalesView />} />} />
        <Route path="/sucursales/editSucursal" element={<PrivateRoute element={<SucursalesEditView />} />} />
        <Route path="/sucursales/createSucursal" element={<PrivateRoute element={<SucursalesCreateView />} />} />

        <Route path="/dispositivo" element={<PrivateRoute element={<DispositivosView />} />} />
        <Route path="/dispositivo/editDispositivo" element={<PrivateRoute element={<DispositivosEditView />} />} />
        <Route path="/dispositivo/createDispositivo" element={<PrivateRoute element={<DispositivosCreateView />} />} />

        <Route path="/empleados" element={<PrivateRoute element={<EmpleadosView />} />} />
        <Route path="/empleados/editEmpleado" element={<PrivateRoute element={<EmpleadosEditView />} />} />
        <Route path="/empleados/createEmpleado" element={<PrivateRoute element={<EmpleadosCreateView />} />} />

        <Route path="/reporte" element={<PrivateRoute element={<ReportView />} />} />

        <Route path="/comandosPendientes" element={<PrivateRoute element={<ComandosPendientesView />} />} />

        <Route path="/horario" element={<PrivateRoute element={<HorarioView />} />} />
        <Route path="/horario/create" element={<PrivateRoute element={<HorarioCreateView />} />} />
        <Route path="/horario/edit" element={<PrivateRoute element={<HorarioEditView />} />} />

        <Route path="/turno" element={<PrivateRoute element={<TurnoView />} />} />
        <Route path="/turno/create" element={<PrivateRoute element={<TurnoCreateView />} />} />
        <Route path="/turno/edit" element={<PrivateRoute element={<TurnoEditView />} />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;
